import React from 'react';
import Badge from './Shared/Badge';
import './Project.css';

function ProjectCard({ title, description, exploreLinks, technologies }) {
    return (
        <div className="card project-card">
            <h5 className="card-header bg-transparent">{title}</h5>
            <div className="card-body project-content">
                <textarea className="textarea-proj" rows="6" cols="50" resize="false" readOnly={true} defaultValue={description}></textarea>
                <div>
                    {
                        exploreLinks.length > 0 ?
                            <div className="info-box">
                                <u>Explore Here:</u>
                                <div className="d-flex align-items-center flex-wrap">
                                    {
                                        exploreLinks.map((item) => (
                                            <Badge key={item.key} openLink={item.openLink}
                                                imageUrl={item.imageUrl}
                                                displayText={item.displayText}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                            : null
                    }
                    {
                        technologies.length > 0 ?
                            <div className="info-box">
                                <u>Technologies:</u>
                                <div className="d-flex align-items-center flex-wrap">
                                    {
                                        technologies.map((item) => (
                                            <Badge key={item.key} openLink={item.openLink}
                                                imageUrl={item.imageUrl}
                                                displayText={item.displayText}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                            : null
                    }
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;